/**
 * Copyright 2014 aixigo AG
 * Released under the MIT license.
 * http://laxarjs.org/license
 */
export default {
   'en': {
      'g': ',',
      'd': '.'
   },
   'ar-ma': {
      'g': '٬',
      'd': '٫'
   },
   'ar': {
      'g': '٬',
      'd': '٫'
   },
   'bg': {
      'g': ' ',
      'd': ','
   },
   'br': {
      'g': ',',
      'd': '.'
   },
   'bs': {
      'g': ',',
      'd': '.'
   },
   'ca': {
      'g': '.',
      'd': ','
   },
   'cs': {
      'g': ' ',
      'd': ','
   },
   'cv': {
      'g': ',',
      'd': '.'
   },
   'da': {
      'g': '.',
      'd': ','
   },
   'de': {
      'g': '.',
      'd': ','
   },
   'el': {
      'g': '.',
      'd': ','
   },
   'en-au': {
      'g': ',',
      'd': '.'
   },
   'en-ca': {
      'g': ',',
      'd': '.'
   },
   'en-gb': {
      'g': ',',
      'd': '.'
   },
   'eo': {
      'g': ',',
      'd': '.'
   },
   'es': {
      'g': '.',
      'd': ','
   },
   'et': {
      'g': ' ',
      'd': ','
   },
   'eu': {
      'g': ',',
      'd': '.'
   },
   'fa': {
      'g': '٬',
      'd': '٫'
   },
   'fi': {
      'g': ' ',
      'd': ','
   },
   'fr-ca': {
      'g': ' ',
      'd': ','
   },
   'fr': {
      'g': ' ',
      'd': ','
   },
   'gl': {
      'g': ',',
      'd': '.'
   },
   'he': {
      'g': ',',
      'd': '.'
   },
   'hi': {
      'g': ',',
      'd': '.'
   },
   'hr': {
      'g': '.',
      'd': ','
   },
   'hu': {
      'g': ' ',
      'd': ','
   },
   'id': {
      'g': '.',
      'd': ','
   },
   'is': {
      'g': ',',
      'd': '.'
   },
   'it': {
      'g': '.',
      'd': ','
   },
   'ja': {
      'g': ',',
      'd': '.'
   },
   'ka': {
      'g': ',',
      'd': '.'
   },
   'ko': {
      'g': ',',
      'd': '.'
   },
   'lt': {
      'g': '.',
      'd': ','
   },
   'lv': {
      'g': ' ',
      'd': ','
   },
   'ml': {
      'g': ',',
      'd': '.'
   },
   'mr': {
      'g': ',',
      'd': '.'
   },
   'ms-my': {
      'g': ',',
      'd': '.'
   },
   'nb': {
      'g': ' ',
      'd': ','
   },
   'ne': {
      'g': ',',
      'd': '.'
   },
   'nl': {
      'g': '.',
      'd': ','
   },
   'nn': {
      'g': ',',
      'd': '.'
   },
   'pl': {
      'g': ' ',
      'd': ','
   },
   'pt-br': {
      'g': '.',
      'd': ','
   },
   'pt': {
      'g': '.',
      'd': ','
   },
   'ro': {
      'g': '.',
      'd': ','
   },
   'ru': {
      'g': ' ',
      'd': ','
   },
   'sk': {
      'g': ' ',
      'd': ','
   },
   'sl': {
      'g': '.',
      'd': ','
   },
   'sq': {
      'g': ',',
      'd': '.'
   },
   'sv': {
      'g': ' ',
      'd': ','
   },
   'th': {
      'g': ',',
      'd': '.'
   },
   'tr': {
      'g': '.',
      'd': ','
   },
   'tzm-la': {
      'g': ',',
      'd': '.'
   },
   'tzm': {
      'g': ',',
      'd': '.'
   },
   'uk': {
      'g': ' ',
      'd': ','
   },
   'uz': {
      'g': ',',
      'd': '.'
   },
   'vn': {
      'g': ',',
      'd': '.'
   },
   'zh-cn': {
      'g': ',',
      'd': '.'
   },
   'zh-tw': {
      'g': ',',
      'd': '.'
   }
};



// WEBPACK FOOTER //
// ./lib/number_formats.js